module.exports = __webpack_public_path__ + "static/media/1.801ce87f.png";